import axios from "axios";
import { IResponseFooter } from "./types";

export const getFooter = async () => {
  const response = await axios.get<IResponseFooter>(`/footer?populate=*`);
  return response.data;
};
